(function(){
  var root = document.getElementById('brb-vip');
  if(!root || root.__brb) return; root.__brb = true;
  var cfg = {}; try{ cfg = JSON.parse(root.querySelector('[data-brb-config]').textContent); }catch(e){}
  var LINK = ''; try{ LINK = cfg.k ? atob(cfg.k) : ''; }catch(e){}
  var STORE = 'brb_vip_black26';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function(s,c){ return (c||root).querySelector(s); };
  var $$ = function(s,c){ return Array.prototype.slice.call((c||root).querySelectorAll(s)); };

  /* ---------- utilidades ---------- */
  function uid(){ try{ if(crypto.randomUUID) return crypto.randomUUID(); }catch(e){} return 'x'+Date.now().toString(36)+Math.random().toString(36).slice(2,10); }
  function cookie(n){ var m = document.cookie.match('(?:^|; )'+n+'=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  function qp(n){ try{ return new URLSearchParams(location.search).get(n) || ''; }catch(e){ return ''; } }
  function store(v){ try{ if(v===undefined) return JSON.parse(localStorage.getItem(STORE)||'null'); localStorage.setItem(STORE, JSON.stringify(v)); }catch(e){ return null; } }
  function fbc(){
    var c = cookie('_fbc'); if(c) return c;
    var id = qp('fbclid'); return id ? 'fb.1.'+Date.now()+'.'+id : '';
  }
  function attribution(){
    var a = {}; ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid'].forEach(function(k){ a[k] = qp(k); });
    a.fbp = cookie('_fbp'); a.fbc = fbc(); a.page_url = location.href.split('#')[0]; a.referrer = document.referrer || ''; a.user_agent = navigator.userAgent;
    return a;
  }
  /* guarda as UTMs da primeira visita, para não perder se a pessoa navegar */
  (function(){ try{ var s = sessionStorage.getItem(STORE+'_utm'); if(!s && location.search) sessionStorage.setItem(STORE+'_utm', location.search); }catch(e){} })();

  /* ---------- Meta Pixel ---------- */
  function ensurePixel(){
    if(typeof window.fbq === 'function' || !cfg.pixelFallback || !cfg.pixelId) return;
    try{ if(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.marketingAllowed && Shopify.customerPrivacy.marketingAllowed() === false) return; }catch(e){}
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', cfg.pixelId);
  }
  setTimeout(ensurePixel, 2500);
  function track(name, data, eventID, custom){
    try{
      ensurePixel();
      if(typeof window.fbq !== 'function') return;
      if(cfg.pixelId) fbq(custom ? 'trackSingleCustom' : 'trackSingle', cfg.pixelId, name, data || {}, { eventID: eventID });
      else fbq(custom ? 'trackCustom' : 'track', name, data || {}, { eventID: eventID });
    }catch(e){}
  }
  function publish(name, data){
    try{ window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); }catch(e){}
    try{ if(typeof window.gtag === 'function') gtag('event', name === 'brb_vip_lead' ? 'generate_lead' : name, data); }catch(e){}
    try{ if(window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); }catch(e){}
  }
  function send(payload){
    if(!cfg.endpoint) return;
    var body = JSON.stringify(payload);
    try{
      fetch(cfg.endpoint, { method:'POST', mode:'no-cors', keepalive:true, headers:{ 'Content-Type':'text/plain;charset=utf-8' }, body: body })
        .catch(function(){ try{ navigator.sendBeacon && navigator.sendBeacon(cfg.endpoint, body); }catch(e){} });
    }catch(e){ try{ navigator.sendBeacon && navigator.sendBeacon(cfg.endpoint, body); }catch(_){} }
  }

  /* ---------- vídeos ---------- */
  var bg = $('video[data-bg]');
  var saveData = navigator.connection && navigator.connection.saveData;
  if(bg && !reduce && !saveData){ bg.autoplay = true; var p = bg.play(); if(p && p.catch) p.catch(function(){}); }
  var vids = $$('video[data-auto]');
  function loadVid(v){ var s = v.querySelector('source[data-src]'); if(s){ s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); v.load(); } }
  if('IntersectionObserver' in window){
    var vio = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var v = e.target;
        if(e.isIntersecting && e.intersectionRatio >= .5){ if(reduce || saveData) return; loadVid(v); var pr = v.play(); if(pr && pr.catch) pr.catch(function(){}); }
        else if(!v.paused){ v.pause(); }
      });
    }, { threshold:[0,.5] });
    vids.forEach(function(v){ vio.observe(v); });
  }
  vids.forEach(function(v){ v.addEventListener('click', function(){ loadVid(v); if(v.paused){ v.play(); } else { v.pause(); } }); });

  /* ---------- entrada no scroll + contadores ---------- */
  function countUp(el){
    var to = parseInt(el.getAttribute('data-countup'),10); if(!to || reduce) return;
    var t0 = null, dur = 1100;
    function step(t){ if(!t0) t0 = t; var k = Math.min(1,(t-t0)/dur); k = 1 - Math.pow(1-k,3); el.textContent = Math.round(to*k); if(k<1) requestAnimationFrame(step); }
    el.textContent = '0'; requestAnimationFrame(step);
  }
  if('IntersectionObserver' in window){
    var rio = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        e.target.classList.add('is-in');
        $$('[data-countup]', e.target).forEach(countUp);
        rio.unobserve(e.target);
      });
    }, { threshold:.18, rootMargin:'0px 0px -6% 0px' });
    $$('[data-reveal], [data-race]').forEach(function(el){ rio.observe(el); });
  } else { $$('[data-reveal], [data-race]').forEach(function(el){ el.classList.add('is-in'); }); }

  /* ---------- contador ---------- */
  var target = Date.parse(cfg.target || '2026-11-20T00:00:00-03:00');
  var sec = $('[data-count-sec]');
  var units = { d:$('[data-u="d"]'), h:$('[data-u="h"]'), m:$('[data-u="m"]'), s:$('[data-u="s"]') };
  var last = {};
  function pad(n){ return n < 10 ? '0'+n : ''+n; }
  function tick(){
    var diff = Math.max(0, target - Date.now());
    if(diff <= 0){ sec.classList.add('is-open'); return false; }
    var s = Math.floor(diff/1000), v = { d:Math.floor(s/86400), h:Math.floor(s%86400/3600), m:Math.floor(s%3600/60), s:s%60 };
    Object.keys(v).forEach(function(k){
      var txt = pad(v[k]); if(last[k] === txt) return; last[k] = txt;
      var span = document.createElement('span'); span.textContent = txt; if(!reduce && last.__init) span.className = 'tick';
      units[k].replaceChildren ? units[k].replaceChildren(span) : (units[k].innerHTML = '', units[k].appendChild(span));
    });
    last.__init = true; return true;
  }
  if(tick()){ var ti = setInterval(function(){ if(!tick()) clearInterval(ti); }, 1000); }

  /* ---------- formulário ---------- */
  var card = $('.brb-card'), form = $('[data-form]'), unlock = $('[data-unlock]');
  var linkField = $('[data-linkfield]'), groupBtn = $('[data-group]'), copyBtn = $('[data-copy]');
  var phone = form.elements.phone;
  phone.addEventListener('input', function(){
    var d = phone.value.replace(/\D/g,'').replace(/^55(?=\d{10,11}$)/,'').slice(0,11), o = d;
    if(d.length > 2) o = '('+d.slice(0,2)+') '+d.slice(2);
    if(d.length > 6) o = '('+d.slice(0,2)+') '+d.slice(2, d.length === 11 ? 7 : 6)+'-'+d.slice(d.length === 11 ? 7 : 6);
    phone.value = o;
  });
  var started = false;
  form.addEventListener('focusin', function(){
    if(started) return; started = true;
    track('IniciouCadastroVIP', { content_name:'Grupo VIP Black 2026' }, 'start.'+uid(), true);
  });
  function fieldErr(input, on){ var f = input.closest('.brb-field'); if(on){ f.removeAttribute('data-err'); void f.offsetWidth; f.setAttribute('data-err',''); } else { f.removeAttribute('data-err'); } }
  $$('input', form).forEach(function(i){ i.addEventListener('input', function(){ fieldErr(i,false); }); });

  function setLinkUI(){
    linkField.value = LINK || 'O link aparece aqui em instantes';
    if(LINK){ groupBtn.href = LINK; } else { groupBtn.removeAttribute('href'); groupBtn.setAttribute('aria-disabled','true'); }
  }
  function firstName(n){ return (n||'').trim().split(/\s+/)[0] || ''; }
  function openUnlocked(name, animate){
    setLinkUI();
    var fn = firstName(name); $('[data-firstname]').textContent = fn ? ', '+fn : '';
    if(!animate){ card.style.animation = 'none'; card.style.opacity = 1; card.style.transform = 'none'; $$('.brb-unlock, .brb-form, .brb-ok__ic, .brb-ok__ic path', card).forEach(function(el){ el.style.transition = 'none'; el.style.animation = 'none'; }); $('.brb-ok__ic').style.opacity = 1; $('.brb-ok__ic').style.transform = 'none'; $('.brb-ok__ic path').style.strokeDashoffset = 0; }
    card.classList.add('is-unlocked');
    setTimeout(function(){ card.classList.add('is-done'); }, animate ? 320 : 0);
    form.setAttribute('aria-hidden','true'); $$('input,button', form).forEach(function(el){ el.tabIndex = -1; });
    root.classList.add('is-member');
    var lab = $('[data-docklabel]'); if(lab) lab.textContent = 'Abrir o Grupo VIP';
    var fl = $('[data-final-label]'); if(fl) fl.textContent = 'Abrir o Grupo VIP';
    if(animate){ setTimeout(function(){ try{ unlock.focus({ preventScroll:true }); }catch(e){} }, 400); }
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var n = form.elements.name, em = form.elements.email;
    var name = n.value.trim(), email = em.value.trim().toLowerCase(), digits = phone.value.replace(/\D/g,'');
    var bad = [];
    if(name.length < 2) bad.push(n);
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) bad.push(em);
    if(digits.length < 10 || digits.length > 11) bad.push(phone);
    $$('input', form).forEach(function(i){ fieldErr(i, bad.indexOf(i) > -1); });
    if(bad.length){ bad[0].focus(); return; }

    var btn = form.querySelector('button[type="submit"]'); btn.setAttribute('aria-busy','true');
    var lead = uid(), evLead = 'lead.'+lead;
    var a = attribution();
    var payload = Object.assign({ action:'lead', lead_id:lead, event_id:evLead, name:name, email:email, phone:'55'+digits, campaign:cfg.campaign, ts:new Date().toISOString() }, a);
    try{ var u = sessionStorage.getItem(STORE+'_utm'); if(u){ var sp = new URLSearchParams(u); ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid'].forEach(function(k){ if(!payload[k] && sp.get(k)) payload[k] = sp.get(k); }); } }catch(err){}
    send(payload);
    track('Lead', { content_name:'Grupo VIP Black 2026', content_category:'black_2026', lead_type:'grupo_vip_whatsapp', currency:'BRL', value:0 }, evLead);
    publish('brb_vip_lead', { lead_id:lead, campaign:cfg.campaign });
    store({ lead_id:lead, name:name, at:Date.now() });
    setTimeout(function(){ btn.removeAttribute('aria-busy'); openUnlocked(name, !reduce); }, 650);
  });

  /* clique no grupo = conversão principal do aquecimento */
  groupBtn.addEventListener('click', function(e){
    if(!LINK){ e.preventDefault(); return; }
    var s = store() || {}; var lead = s.lead_id || uid(); var ev = 'grp.'+lead;
    track('CompleteRegistration', { content_name:'Grupo VIP Black 2026', status:'entrou_no_grupo', currency:'BRL', value:0 }, ev);
    publish('brb_vip_group_click', { lead_id:lead, campaign:cfg.campaign });
    send(Object.assign({ action:'group_click', lead_id:lead, event_id:ev, ts:new Date().toISOString() }, attribution()));
  });

  copyBtn.addEventListener('click', function(){
    if(!LINK) return;
    var done = function(){
      copyBtn.classList.add('copied'); copyBtn.setAttribute('aria-label','Link copiado');
      clearTimeout(copyBtn.__t); copyBtn.__t = setTimeout(function(){ copyBtn.classList.remove('copied'); copyBtn.setAttribute('aria-label','Copiar link do grupo'); }, 2200);
      var s = store() || {}; track('CopiouLinkGrupoVIP', { content_name:'Grupo VIP Black 2026' }, 'copy.'+(s.lead_id || uid()), true);
    };
    if(navigator.clipboard && window.isSecureContext){ navigator.clipboard.writeText(LINK).then(done, function(){ legacy(); }); } else { legacy(); }
    function legacy(){ linkField.select(); linkField.setSelectionRange(0, 9999); try{ document.execCommand('copy'); done(); }catch(e){} }
  });

  /* rolar até o formulário / abrir o grupo */
  $$('[data-tofrm], [data-dockbtn]').forEach(function(a){
    a.addEventListener('click', function(e){
      if(root.classList.contains('is-member') && LINK){ e.preventDefault(); groupBtn.click(); return; }
      e.preventDefault();
      card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block:'center' });
      setTimeout(function(){ try{ form.elements.name.focus({ preventScroll:true }); }catch(err){} }, reduce ? 0 : 550);
    });
  });

  /* CTA fixo: aparece quando o formulário sai da tela e some no CTA final */
  var dock = $('[data-dock]');
  if(dock && 'IntersectionObserver' in window){
    var cardVisible = true, finalVisible = false;
    var upd = function(){ var on = !cardVisible && !finalVisible; dock.classList.toggle('is-on', on); dock.setAttribute('aria-hidden', on ? 'false' : 'true'); var b = $('[data-dockbtn]'); if(b) b.tabIndex = on ? 0 : -1; };
    new IntersectionObserver(function(es){ cardVisible = es[0].isIntersecting; upd(); }, { threshold:0 }).observe(card);
    new IntersectionObserver(function(es){ finalVisible = es[0].isIntersecting; upd(); }, { threshold:.25 }).observe($('.brb-final'));
  }

  /* quem já se cadastrou volta direto pro link */
  var saved = store();
  if(saved && saved.lead_id){ openUnlocked(saved.name, false); }
})();